import DetailViewerContainer from './DetailViewerContainer';
export default DetailViewerContainer;
